/* !
 * ir.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {

	const setNewsList = () => {
		const jsonURL = `/ajax${FUNCTIONS.va.isEnglish ? '/english' : ''}/news/list.json?p_category=ir_news`;
		const jsonURLirPocket = FUNCTIONS.va.isEnglish ? 'https://xml.irpocket.com/4461/JS/release-enall-all.js' : 'https://xml.irpocket.com/4461/JS/release-all-all.js';
		console.log(jsonURL);

		function loadIRPocket() {
			return new Promise((resolve) => {
				window.ir20handler = function (data) {
					resolve(data.item || []);
				};

				const script = document.createElement('script');
				script.src = jsonURLirPocket;
				script.onerror = () => resolve([]); // 失敗しても空配列
				document.body.appendChild(script);
			});
		}
		async function fetchAndMergeNews() {
			const news1Promise = fetch(jsonURL)
				.then(res => res.ok ? res.json() : [])
				.catch(() => []);

			const news2Promise = loadIRPocket();

			const [data1, data2] = await Promise.all([
				news1Promise,
				news2Promise
			]);

			// 日付キーを統一
			const normalized1 = data1.rt_bn_news_list.map(item => ({ ...item, _date: new Date(item.rt_cf_n_date.datetime) }));
			const normalized2 = data2.map(item => ({ ...item, _date: new Date(item.published) }));
			const merged = [...normalized1, ...normalized2];

			// 降順ソート（新しい順）
			merged.sort((a, b) => b._date - a._date);

			return merged;
		}

		fetchAndMergeNews().then(mergedNews => {
			if (mergedNews.length) {

				Vue.createApp({
					data() {
						return {
							jsonData: mergedNews,
							count: 5
						}
					},
					methods: {
						// IRポケット用
						setDate(published) {
							let date = published?.slice(0, 10) ?? ''
							return date.replace(/-/g, '.');
						},
						newIcon(published) { // 一ヶ月以内ならNEW
							const thisDate = new Date(published);
							const now = new Date();
							const aMonthsAgo = new Date(now);
							aMonthsAgo.setMonth(now.getMonth() - 1);
							return thisDate >= aMonthsAgo && thisDate <= now;
						},

						// CMSoD用
						setBr(content) {
							return content.replace(/\r?\n/g, '<br>');
						},
						setAttachment(item) {
							if (item.rt_cf_n_href.class && item.rt_cf_n_href.class === 'rt_cf_nolink') {
								return 'nolink';
							} else if (item.rt_cf_n_href.href.endsWith('.pdf')) {
								return 'pdf';
							} else if (FUNCTIONS.va.newsFileType.some(type => item.rt_cf_n_href.href.endsWith(type))) {
								return 'file';
							} else if (item.rt_cf_n_type3_ext_link_is !== null) {
								return 'blank';
							} else {
								return 'link';
							}
						},
						setTarget(att) {
							if (att === 'link') {
								return '_self';
							} else {
								return '_blank';
							}
						},
						setFilesize(bytes) {
							let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
							if (bytes === 0) {
								return 'n/a';
							}
							let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
							if (i === 0) {
								return bytes + sizes[i];
							}
							return (bytes / Math.pow(1024, i)).toFixed(1) + sizes[i];
						}
					},
					computed: {
						filterItems() {
							let items = this.jsonData;
							let itemsTemp = [];
							let count = this.count;
							if (count > items.length) { count = items.length; }

							for (let i = 0; i < count; i++) {
								itemsTemp.push(items[i]);
							}
							items = itemsTemp;

							return (items);
						}
					}
				}).mount('#vue-app');

				if (FUNCTIONS.va.window.width >= FUNCTIONS.va.device.desktop) {
					setTimeout(() => {
						FUNCTIONS.matchHeight(document.querySelectorAll('.ir-top-news .__inner'));
					}, 200);
				}
			}
		});
	};

	const setIRCalendar = () => {
		fetch(`/ajax${FUNCTIONS.va.isEnglish ? '/english' : ''}/ir/ir-events/calendar/list.json`).then(response => response.json()).then(data => {
			if (data.rt_bn_news_list.length) {

				Vue.createApp({
					data() {
						return {
							jsonData: data.rt_bn_news_list,
							count: 5
						}
					},
					methods: {
						setBr(content) {
							return content.replace(/\r?\n/g, '<br>');
						},
						setAttachment(item) {
							if (item.rt_cf_n_href.class && item.rt_cf_n_href.class === 'rt_cf_nolink') {
								return 'nolink';
							} else if (item.rt_cf_n_href.href.endsWith('.pdf')) {
								return 'pdf';
							} else if (FUNCTIONS.va.newsFileType.some(type => item.rt_cf_n_href.href.endsWith(type))) {
								return 'file';
							} else if (item.rt_cf_n_type3_ext_link_is !== null) {
								return 'blank';
							} else {
								return 'link';
							}
						},
						setTarget(att) {
							if (att === 'link') {
								return '_self';
							} else {
								return '_blank';
							}
						},
						setFilesize(bytes) {
							let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
							if (bytes === 0) {
								return 'n/a';
							}
							let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
							if (i === 0) {
								return bytes + sizes[i];
							}
							return (bytes / Math.pow(1024, i)).toFixed(1) + sizes[i];
						}
					},
					computed: {
						filterItems() {
							let items = this.jsonData;
							let itemsTemp = [];
							let count = this.count;
							if (count > items.length) { count = items.length; }

							for (let i = 0; i < count; i++) {
								itemsTemp.push(items[i]);
							}
							items = itemsTemp;

							return (items);
						}
					}
				}).mount('#vue-app_calendar');
			}
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsListFUNCTIONS = () => {
		setNewsList();
		setIRCalendar();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsListFUNCTIONS(); }) : newsListFUNCTIONS();

})(window.FUNCTIONS);
